import React, { PropTypes, Component } from 'react'
import constants from 'constants'
import { Progress } from '.'
// import moment from 'moment'
import { format } from 'date-fns'

class SubmittedPlan extends Component {
    static propTypes = {
      currentUser: PropTypes.object.isRequired,
      handleAgreePlan: PropTypes.func.isRequired,
      handleUpload: PropTypes.func.isRequired,
      partnerPlan: PropTypes.object.isRequired,
      selectedPlan: PropTypes.instanceOf(Array).isRequired,
    }

    render() {
      const {
        partnerPlan,
        selectedPlan,
        handleUpload,
        handleAgreePlan,
      } = this.props

      const steps = [
        {
          key: 1,
          label: constants.PARTNERPLAN.STEPS.UPLOAD,
          desc: `${constants.PARTNERPLAN.STATUS.UPLOADED}: ${(partnerPlan.partnerPlan.planUploadedDate ?
            format(new Date(partnerPlan.partnerPlan.planUploadedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
          isDone: true,
          isCurrent: false,
          actions: [
            {
              label: 'REPLACE',
              onClick: handleUpload,
              active: true,
              show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.MYPLANS && this.props.currentUser.IsAdmin === true),
            },
          ],
        },
        {
          key: 2,
          label: constants.PARTNERPLAN.STEPS.SUBMIT,
          desc: `${constants.PARTNERPLAN.STATUS.SUBMITTED}: ${format(new Date(partnerPlan.partnerPlan.planSubmittedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM)}`,
          isDone: true,
          isCurrent: true,
          actions: [
            {
              label: 'AGREE',
              onClick: handleAgreePlan,
              // active: true,
              show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP),
            },
          ],
        },
        {
          key: 3,
          label: constants.PARTNERPLAN.STEPS.AGREED,
          desc: 'Pending',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 4,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 5,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_SUBMITTED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 6,
          label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 7,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 8,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_SUBMITTED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
        {
          key: 9,
          label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_AGREED,
          desc: '',
          isDone: false,
          isCurrent: false,
          actions: [],
        },
      ]

      return (
        <Progress steps={steps} />
      )
    }
}

export default SubmittedPlan



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/SubmittedPlan.js